<template lang="pug">
.rc
  .rc__card
    h1.rc__title Bienvenido a Samtek Center
    p.rc__text Por favor inicia sesión para continuar
    p.rc__error.text-center(v-if="errors.invalidCredentials") Correo o contraseña inválido
    p.rc__error.text-center(v-if="errors.permissionDetail") {{ errors.permissionDetail }}
    form.rc__form(@submit="onSubmit")
      .rc__field
        label.rc__label(for="login-email") Correo
        input#login-email.rc__input(
          type="email"
          :value="form.email"
          @input="(e)=>{form.email=e.target.value}"
          autocomplete="email"
          required
          placeholder="Ingresa tu Correo"
        )
      .rc__field
        label.rc__label(for="login-password") Contraseña
        .rc__input-wrap
          input#login-password.rc__input.rc__input--password(
            :type="verPassword ? 'text' : 'password'"
            :value="form.password"
            @input="(e)=>{form.password=e.target.value}"
            autocomplete="current-password"
            required
            placeholder="Ingresa tu Contraseña"
          )
          button.rc__toggle(
            type="button"
            :aria-label="verPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            @click="verPassword = !verPassword"
          )
            img(v-if="verPassword" src="@/assets/recuperar-clave/eye-outline.svg" alt="")
            img(v-else src="@/assets/recuperar-clave/eye-off-outline.svg" alt="")
        router-link.rc__link(:to="{ name: 'Recuperar Clave' }") ¿Olvidaste tu contraseña?
      .rc__actions
        button.rc__btn.rc__btn--primary(type="submit" :disabled="loading")
          | Iniciar Sesión
          b-spinner(v-if="loading" small)
    .rc__actions
      router-link.rc__btn.rc__btn--link(:to="{ name: 'Registro Retail' }") Registro usuarios retail
</template>

<script>
import { mapActions } from 'vuex'
import { clientesSubdomain } from '../../../settings'
import initializeFirebase from '../../shared/firebase'

export default {
  data() {
    return {
      loading: false,
      verPassword: false,
      form: {
        email: '',
        password: '',
      },
      errors: {
        invalidCredentials: false,
        permissionDetail: '',
      },
    }
  },
  created() {
    // eslint-disable-next-line
    if (location.host.toString() === clientesSubdomain) {
      this.$router.push('/cliente')
    }
  },
  methods: {
    ...mapActions('AuthenticationStore', ['registerFCMDevice']),
    ...mapActions('AuthenticationStore', ['login']),
    async initFirebase() {
      const token = await initializeFirebase()
      if (token) {
        this.registerFCMDevice({ device_token: token })
      }
    },
    async onSubmit(event) {
      event.preventDefault()
      this.loading = true
      this.errors.permissionDetail = ''
      this.errors.invalidCredentials = false

      try {
        const response = await this.login(this.form)

        if (!response) {
          this.errors.invalidCredentials = true
        } else {
          try {
            await this.initFirebase()
          } catch (e) {
            console.error('Firebase error', e)
          }
          this.$router.push('/')
        }
      } catch (err) {
        console.error(err)
        this.errors.permissionDetail = err.message || 'Error de permisos'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/auth-card.scss';
</style>
